import { ListItem, ListItemProps } from '@mui/material'
import React, { FC } from 'react'

const ListItemWrapper: FC<ListItemProps> = ({ ...props }) => <ListItem {...props} />

export default ListItemWrapper
